//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import SVGLoader from "../../UI/SVGLoader"
import { ContactPanelContainer, PanelIcon } from "./UI"
import { ContactKeyboardField, ContactField, FormGroup } from "../../UI/Form"
import Button from "../Shared/Button"
import styled from "styled-components"

const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin: 72px 10px 10px 10px;
  align-items: center;
  width: 100%;
`

const Disclaimer = styled.h3`
  font-family: "din-condensed";
  font-size: 1.25rem;
  font-style: italic;
  font-weight: 300;
  color: #fff;
  margin: 0.25rem auto;
`

const WideGroup = FormGroup.extend`
  width: 100%;

  & > div {
    margin: auto;
  }
`

export const ContactPanel = ({
  icon,
  placeholder,
  disclaimer,
  buttonText,
  handleSubmit,
  error,
  normalize,
  innerRef,
  reset,
  usesVirtualKeyboard
}: {
  icon: string,
  disclaimer?: string,
  placeholder: string,
  buttonText: string,
  handleSubmit: Function,
  normalize?: ?(value: string) => boolean,
  innerRef: (el: HTMLElement) => any,
  reset: Function,
  usesVirtualKeyboard: Boolean
}) => (
  <ContactPanelContainer innerRef={innerRef}>
    <PanelIcon>
      <SVGLoader path={icon} height="100%" width="100%" fill="#fff" />
    </PanelIcon>
    <Form
      onSubmit={values => {
        handleSubmit(values)
        reset()
      }}
    >
      <WideGroup>
        <Field
          name="contact"
          normalize={normalize}
          component={usesVirtualKeyboard ? ContactKeyboardField : ContactField}
          type="text"
          placeholder={placeholder}
        />
      </WideGroup>
      <Button>{buttonText}</Button>
      {disclaimer ? <Disclaimer>{disclaimer}</Disclaimer> : <span />}
    </Form>
  </ContactPanelContainer>
)

export default (name: string, validate: Function) =>
  reduxForm({ form: name, validate })(ContactPanel)



// WEBPACK FOOTER //
// ./src/Kiosk/TellMeMoreView/ContactPanel.js